<div class=" py-2 mx-auto xxl:w-full max-w-6xl">
    <div class="flex justify-between items-center">
        <h2 class="text-xl  font-bold p-2 text-gray-600">Higher Authority Approvals</h2>
        <div class="flex gap-3 mr-2">
            <button 
                [disabled]="selectedProposals.length === 0"
                class="px-2 rounded border-2 border-green-500 relative flex items-center"
                [ngClass]="{
                  'bg-green-100 text-green-500': selectedProposals.length > 0,
                  'bg-green-50 text-green-500 border-green-200 cursor-not-allowed opacity-50': selectedProposals.length === 0,
                  'hover:bg-green-500 hover:text-white': selectedProposals.length > 0
                }"
                (click)="onApprove($event)">
                <span class="inline-flex items-center justify-center w-5 h-5 rounded-full border-2"
                    [ngClass]="{
                      'bg-green-100 border-green-400': selectedProposals.length > 0,
                      'bg-green-50 border-green-200': selectedProposals.length === 0
                    }">
                  <i class="pi pi-check"
                    [ngClass]="{
                      'text-green-600': selectedProposals.length > 0,
                      'text-green-200': selectedProposals.length === 0
                    }"
                    text-sm>
                  </i>
                </span>
                Approve
            </button>
            <button 
                [disabled]="selectedProposals.length === 1"
                class="px-2 rounded border-2 border-red-500 relative flex items-center"
                [ngClass]="{
                  'bg-red-100 text-red-500': selectedProposals.length > 0,
                  'bg-red-50 text-red-500 border-red-200 cursor-not-allowed opacity-50': selectedProposals.length === 0,
                  'hover:bg-red-500 hover:text-white': selectedProposals.length > 0
                }"
                (click)="openDialog(2)">
                <span class="inline-flex items-center justify-center w-5 h-5 rounded-full border-2"
                    [ngClass]="{
                      'bg-red-100 border-red-400': selectedProposals.length > 0,
                      'bg-red-50 border-red-200': selectedProposals.length === 0
                    }">
                  <i class="pi pi-exclamation-circle"
                    [ngClass]="{
                      'text-red-600': selectedProposals.length > 0,
                      'text-red-200': selectedProposals.length === 0
                    }"
                    text-sm
                  ></i>
                </span>
                Under deliberation
            </button>
        </div>
    </div>

  <p-table
    [value]="proposalData"
    [paginator]="proposalData.length > 10"
    [rows]="10"
   
    styleClass="w-full min-h-[50vh] "
    selectionMode="multiple"

    [(selection)]="selectedProposals"
    dataKey="proposal_step_id"
    
  >
    <ng-template pTemplate="header">
      <tr class="bg-gray-100 border-b text-sm">
        
        <th class="text-center px-3 py-2 font-semibold text-sm"></th>
        <!-- <th class="text-center px-3 py-2 font-semibold text-sm">#</th> -->
        <th class="text-left px-3 py-2 font-semibold text-sm" pSortableColumn="proposal_name" pResizableColumn>
          <div class="flex items-center gap-2 text-sm">
            <span>Proposal Name</span>
            <p-sortIcon field="proposal_name"></p-sortIcon>
            <p-columnFilter class="text-gray-600" field="proposal_name" type="text" display="menu" [showAddButton]="false"></p-columnFilter>
          </div>
        </th>
        <th class="text-left px-3 py-2 font-semibold text-sm min-w-[300px]" pSortableColumn="need_generation.challenge_brief" pResizableColumn>
          <div class="flex items-center gap-2 text-sm">
            <span>Description</span>
            <p-sortIcon field="need_generation.challenge_brief"></p-sortIcon>
            <p-columnFilter class="text-gray-600" field="need_generation.challenge_brief" type="text" display="menu" [showAddButton]="false"></p-columnFilter>
          </div>
        </th>
        <th class="text-left px-3 py-2 font-semibold text-sm" pSortableColumn="proposal_step_name" pResizableColumn>
          <div class="flex items-center gap-2 text-sm">
            <span>Current Step</span>
            <p-sortIcon field="proposal_step_name"></p-sortIcon>
            <p-columnFilter class="text-gray-600" field="proposal_step_name" type="text" display="menu" [showAddButton]="false"></p-columnFilter>
          </div>
        </th>
       
        <th class="text-center px-3 py-2 font-semibold text-sm" pSortableColumn="proposal_status" pResizableColumn>
          <div class="flex items-center justify-center gap-2 text-sm">
            <span>Proposal Status</span>
            <p-sortIcon field="proposal_status"></p-sortIcon>
            <p-columnFilter class="text-gray-600" field="proposal_status" type="text" display="menu" [showAddButton]="false"></p-columnFilter>
          </div>
        </th>
        <th class="text-center px-3 py-2 font-semibold text-sm" pSortableColumn="received_from" pResizableColumn>
            <div class="flex items-center gap-2 text-sm">
                <span>Received From</span>
                <p-sortIcon field="received_from"></p-sortIcon>
                <p-columnFilter class="text-gray-600" field="received_from" type="text" display="menu" [showAddButton]="false"></p-columnFilter>
              </div>
        </th>
        <th class="text-center px-3 py-2 font-semibold text-sm" pSortableColumn="received_to" pResizableColumn>
          <div class="flex items-center justify-center gap-2 text-sm">
            <span>Created On</span>
            <p-sortIcon field="received_to"></p-sortIcon>
            <p-columnFilter class="text-gray-600" field="received_to" type="date" display="menu" [showAddButton]="false"></p-columnFilter>
          </div>
        </th>
        <th class="text-center px-3 py-2 font-semibold text-sm" pSortableColumn="scheme_name" pResizableColumn>
          <div class="flex items-center justify-center gap-2 text-sm">
            <span>Scheme Name</span>
            <p-sortIcon field="scheme_name"></p-sortIcon>
            <p-columnFilter class="text-gray-600" field="scheme_name" type="text" display="menu" [showAddButton]="false"></p-columnFilter>
          </div>
        </th>
        <th class="text-center px-3 py-2 font-semibold text-sm">View Report</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-proposal let-rowIndex="rowIndex">
      <tr (dblclick)="getProposalSteps(proposal)" class="hover:bg-blue-50 transition-colors border-b text-sm">
          <td  class="align-middle px-2 py-2 border-b border-gray-100">
            <p-tableCheckbox [value]="proposal"></p-tableCheckbox>
            </td>
        <td class="px-3 py-2 text-gray-800 text-sm">{{ proposal?.proposal_name || '-' }}</td>
        <td class="px-3 py-2 text-sm min-w-2xl">
          <div class="relative group min-w-2xl">
            <span 
              class="line-clamp-2 transition-all duration-200 cursor-pointer "
              [innerHTML]="proposal?.need_generation?.challenge_brief || proposal?.need_generation?.brief || '-'">
            </span>
            <div
            class="
              absolute z-0 hidden group-hover:block
              top-full left-0 top-0 t-1
              w-64
              max-h-40
              overflow-y-auto
              rounded-md
              border border-gray-300
              bg-white
              p-2
              text-xs
              text-gray-800
              shadow-lg
              whitespace-pre-line
              break-words
            "
            [innerHTML]="proposal?.need_generation?.challenge_brief || proposal?.need_generation?.brief || '-'">
            >
          </div>
          </div>
        </td>
        
        <td class="px-3 py-2 text-sm">
          <a  class="text-blue-700 font-semibold hover:underline text-sm">
            {{ proposal?.proposal_step_name || '-' }}
          </a>
        </td>
        <!-- <td class="px-3 py-2 text-gray-800 text-sm">{{ proposal?.description || proposal?.need_generation?.description || '-' }}</td> -->
        <td class="text-center px-3 py-2 text-sm">
        <span [ngClass]="getStatusBadgeClass(proposal?.proposal_status)">{{ proposal?.proposal_status | lowercase }}
        </span>
        </td>
        <td class="text-center px-3 py-2 text-sm">
        <span  class="text-xs font-semibold text-amber-500 bg-amber-50 border border-amber-500 rounded px-2 py-1">{{ proposal?.last_approved_by | uppercase }}
        </span>
        </td>
        <td class="text-center px-3 py-2 text-sm">
          <span class="  gap-2 border border-gray-300 rounded px-2 py-1 text-sm bg-slate-100 text-gray-500">
            <i class="pi pi-calendar text-gray-500 text-sm"></i>
            {{ proposal?.need_generation?.created_on | date:'dd-MM-yyyy' }}
          </span>
        </td>
        <td class="text-center px-3 py-2 text-sm">{{ proposal?.scheme_name || '-' }}</td>
        <td class="text-center px-3 py-2 text-sm">
          <button (click)="getApiResponse(proposal)" class="border border-blue-500 text-blue-500 hover:bg-blue-50 rounded px-2 py-1 mr-1 transition-colors text-sm" title="View">
            <i class="pi pi-eye"></i>
          </button>
          <button *ngIf="proposal?.canEdit"  class="border border-gray-300 text-gray-600 hover:bg-gray-100 rounded px-2 py-1 transition-colors text-sm" title="Edit">
            <i class="pi pi-pencil"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9">
          <div class="py-5 flex flex-col items-center justify-center gap-3">
            <span><i class="pi pi-folder-open text-4xl text-gray-300"></i></span>
            <div class="font-semibold text-gray-800 text-lg">No proposals found</div>
            <div class="text-gray-500 text-center">
              There are currently no proposals to display in this list.<br>
              Please check back later or adjust your filters.
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  
</div>

<!-- Tailwind CSS Popup Modal for Proposal Details -->
<div 
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 bg-opacity-80 transition-all duration-200"
  *ngIf="isApproveDialogVisible"
>
  <div class="relative bg-white/90 rounded shadow-2xl w-full max-w-8xl mx-4 md:mx-0">
    <!-- Header -->
    <div class="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-gray-50 rounded-t-lg">
      <h2 class="text-xl font-bold text-gray-800">Proposal Details</h2>
      <div class="flex items-center gap-1">
        <button
          (click)="isApproveDialogVisible = false ; apiResponse=null"
          class="ml-2 p-1 rounded-xl hover:bg-gray-200 text-gray-600 focus:outline-none"
          aria-label="Close"
          type="button"
        >
          <i class="pi pi-times text-xl"></i>
        </button>
<!--                                           
        <button
          class="ml-2 p-1 rounded-xl bg-blue-100 text-blue-700 hover:bg-blue-200 focus:outline-none"
          aria-label="Export as Word"
          title="Export as Word"
          type="button"
        >
          <i class="pi pi-file-word text-xl"></i>
        </button>
        <button
          class="ml-2 p-1 rounded-xl bg-pink-100 text-pink-700 hover:bg-pink-200 focus:outline-none"
          aria-label="Export as PDF"
          title="Export as PDF"
          type="button"
        >
          <i class="pi pi-file-pdf text-xl"></i>
        </button>
        <button
          class="ml-2 p-1 rounded-xl bg-orange-100 text-orange-700 hover:bg-orange-200 focus:outline-none"
          aria-label="Print"
          title="Print"
          type="button"
        >
          <i class="pi pi-print text-xl"></i>
        </button> -->
      </div>
    </div>

    <!-- Modal Content -->
    <div class="pb-3 overflow-y-auto max-h-[90vh]">
      <!-- <div class="grid grid-cols-1 sm:grid-cols-4 border-2 border-gray-600 overflow-hidden rounded-lg">
        <ng-container *ngFor="let item of currectPraposalView?.keys?.fields">
          <div class="border-b-2 border-r-2 border-gray-600 p-2 font-semibold text-gray-700 flex items-center bg-gray-50">
            {{ item.label }}:
          </div>
          <div 
            *ngIf="checkIsHtml(getNestedValue(currectPraposalView, item.key))"
            class="border-b-2 col-span-3 border-gray-600 p-2 text-gray-900 flex items-center"
          >
            <span [innerHTML]="getNestedValue(currectPraposalView, item.key)"></span>
          </div>
          <div 
            *ngIf="!checkIsHtml(getNestedValue(currectPraposalView, item.key))"
            class="border-b-2 col-span-3 border-gray-600 p-2 text-gray-900 flex items-center"
          >
            {{ getNestedValue(currectPraposalView, item.key) || '-' }}
          </div>
        </ng-container>
      </div> -->
      <app-report *ngIf="apiResponse" [apiResponse]="apiResponse"></app-report>
      <div class="border-2 border-gray-600 overflow-hidden rounded-lg mt-6 m-3">
        <div class="bg-gray-100 border-b-2 border-gray-600 px-4 py-2 font-semibold text-gray-700">
          Attached Documents
        </div>
        <ng-container *ngIf="!!documentList?.length; else noDocument">
          <div class="divide-y divide-gray-200">
            <ng-container *ngFor="let doc of documentList">
              <div class="grid grid-cols-1 sm:grid-cols-4 items-center">
                <div class="p-3 border-r-2 border-gray-600 font-semibold text-gray-700 bg-gray-50 flex items-center">
                  <i class="pi pi-file mr-2 text-blue-600" *ngIf="doc.type_document?.includes('pdf'); else defaultIcon"></i>
                  <ng-template #defaultIcon>
                    <i class="pi pi-paperclip mr-2 text-gray-400"></i>
                  </ng-template>
                  {{ doc.name || 'Document' }}
                </div>
                <div class="sm:col-span-3 flex flex-wrap items-center gap-2 p-3">
                  <a 
                    class="inline-flex items-center px-3 py-1 rounded bg-blue-100 text-blue-700 hover:bg-blue-200 transition text-sm font-medium"
                    [href]="baseUrl + doc.file" target="_blank"
                    [attr.download]="doc.name"
                    title="Download/View Document"
                  >
                    <i class="pi pi-download mr-1"></i>
                    View / Download
                  </a>
                  <span class="text-xs ml-2 px-2 py-1 inline-block rounded 
                    "
                    [ngClass]="{
                      'bg-green-100 text-green-700': doc.document_flag,
                      'bg-pink-100 text-pink-700': !doc.document_flag
                    }"
                  >
                    {{ doc.document_flag ? 'Submitted' : 'Not Submitted' }}
                  </span>
                  <span 
                    *ngIf="doc.uploaded_at"
                    class="text-xs text-gray-600 ml-2"
                  >
                    Uploaded: {{ doc.uploaded_at | date:'medium' }}
                  </span>
                  <span 
                    *ngIf="doc.type_document"
                    class="text-xs text-gray-500 ml-2"
                  >
                    [{{ doc.type_document.toUpperCase().replace('.', '') }}]
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #noDocument>
          <div class="p-4 text-gray-500 text-center">No documents attached.</div>
        </ng-template>
      </div>
    </div>

    
  </div>
</div>

<p-toast></p-toast>

<div *ngIf="showConfirm" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
  <div class="bg-white w-full max-w-2xl rounded-md shadow-lg overflow-hidden">

    <div class="px-4 py-3 space-y-3 text-sm" >
      <div class="flex items-center">
        <span class="font-semibold mb-2">Share With : &nbsp; &nbsp; </span>
        <div class="ml-4 flex gap-4">
          <label class="inline-flex items-center gap-1 cursor-pointer">
            <p-radioButton name="shareType" value="internal"  [(ngModel)]="shareType" class="!mb-0 border-2 p-0.5 rounded-full border-gray-500"></p-radioButton>
            <span class="text-sm">Internal</span>
          </label>
          <label class="inline-flex items-center gap-1 cursor-pointer">
            <p-radioButton name="shareType" value="external"  [(ngModel)]="shareType" class="!mb-0 border-2 p-0.5 rounded-full border-gray-500"></p-radioButton>
            <span class="text-sm">External</span>
          </label>
        </div>
      </div>
      <p class="font-semibold mb-2">Send to ({{shareType | titlecase}}) :</p>
      <p-dropdown *ngIf="shareType === 'internal'" id="userSelect" [options]="userList" optionLabel="first_name" filter="true" styleClass="w-100 w-full"
        filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" [(ngModel)]="selectedUser"
        placeholder="Choose a user" appendTo="body" class="w-100">
        <ng-template pTemplate="selectedItem" let-user>
          <div *ngIf="user">
            <small>
              #<strong>{{ user.loginname }}</strong> |
              <strong>{{ user.first_name }} {{ user.last_name }}</strong>
            </small>
          </div>
          <div *ngIf="!user" class="dropdown-placeholder">
            Choose a user
          </div>
        </ng-template>
        <!-- Dropdown list items -->
        <ng-template pTemplate="item" let-user>
          <div class="list-group-item list-group-item-action">
            <small>
              #<strong>{{ user.loginname }}</strong> |
              <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{ user.hrcdf_designation
                }}</strong>
            </small>
          </div>
        </ng-template>
      </p-dropdown>
      <p-dropdown *ngIf="shareType === 'external'"
        id="unitSelect"
        [options]="unitList"
        optionLabel="name"
        optionValue="id"
        placeholder="Choose a directorate"
        [(ngModel)]="selectedUnit"
        styleClass="w-full"
        appendTo="body">
      </p-dropdown>
        


     
    </div>




    <div class="px-4 py-3 border-t bg-gray-50 flex justify-end space-x-2 text-sm">

      <button
        class="px-3 py-1.5 border border-red-500 text-red-600 rounded hover:bg-red-50 hover:text-red-700 transition"
        (click)="showConfirm = false">
        Cancel
      </button>

      <button class="px-3 py-1.5 bg-green-600 text-white rounded hover:bg-green-700 transition" (click)="acceptSelectedProposals()">
        Confirm
      </button>

    </div>

  </div>
</div>


<ng-container *ngIf="displayDialogN">
  <app-scheme-wise-route-popup [displayDialog]="displayDialogN" (closeDialog)="displayDialogN = !displayDialogN" (onSubmit)="onApprove($event)" ></app-scheme-wise-route-popup>
</ng-container>
